// extracted by mini-css-extract-plugin
export default {"root":"tweet-container_root__zGXxr","article":"tweet-container_article__hU2E8"};